import React from 'react';

const ParagraphWrapper = ({ children, dashedBorderColor }) => {
    return (
        <div className="relative mx-0 md:mx-12 mb-12 z-10">
            <div className="bg-[#fff5bf] z-10 p-6 md:p-8">
                {/* <Paragraph className="">{children}</Paragraph> */}
                <div className="text-sm sm:text-lg tracking-normal text-primary2 ">
                    {children}
                </div>
            </div>
            <div
                // corner top left
                className={`absolute top-3 left-3 w-4 h-4 md:top-4 md:left-4 md:w-5 md:h-5 border-t-2 border-l-2 border-primary2/50`}
            ></div>
            <div
                // corner bottom right
                className={`absolute bottom-3 right-3 w-4 h-4 md:bottom-4 md:right-4 md:w-5 md:h-5 border-b-2 border-r-2 border-primary2/50`}
            ></div>
            <div
                // dashed border
                className={`absolute hidden md:block top-3 left-3 -right-3 -bottom-3 md:top-5 md:left-5 md:-right-5 md:-bottom-5 border-2 border-${dashedBorderColor} border-dashed -z-10`}
            ></div>
        </div>
    );
};

export default ParagraphWrapper;
